import { GlobalAxios } from "../axios/axios-config";
import {
  INewTicketFinishReason,
  ITicketFinishReason,
} from "../models/ticket-finish-reason";

const EVENT_TYPE_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketFinishReason/";

export const createTicketFinishReason = (item: INewTicketFinishReason) => {
  return GlobalAxios.post(EVENT_TYPE_ROUTE, item);
};

export const getTicketFinishReasonById = (id: string) => {
  return GlobalAxios.get<ITicketFinishReason>(EVENT_TYPE_ROUTE + id);
};

export const updateTicketFinishReasonById = ({
  item,
  id,
}: {
  item: INewTicketFinishReason;
  id: string;
}) => {
  return GlobalAxios.put(EVENT_TYPE_ROUTE + id, item);
};
